module.exports = __webpack_public_path__ + "img/logo3.9ef6b705.png";